import { initializeApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Main app config
const mainConfig = {
    apiKey: "AIzaSyB5QW9Wack76vdLVeBKlVfLacQismjxCBg",
    authDomain: "konzo-vibes.firebaseapp.com",
    projectId: "konzo-vibes",
    storageBucket: "konzo-vibes.appspot.com",
    messagingSenderId: "542289244063",
    appId: "1:542289244063:web:4c8983b92b48f87e3417aa",
    measurementId: "G-6CFPP72K5C"
};

// E-commerce config
const ecommerceConfig = {
    apiKey: "AIzaSyAHVoDm6rqEvUc8C8oqki4kpjLd2MxhYw8",
    authDomain: "konzo-marketplace.firebaseapp.com",
    projectId: "konzo-marketplace",
    storageBucket: "konzo-marketplace.firebasestorage.app",
    messagingSenderId: "177859503793",
    appId: "1:177859503793:web:e5d72f16cc47bf0bce6490",
    measurementId: "G-LGRMWP1HBN"
};

// Initialize Firebase apps
const mainApp = initializeApp(mainConfig, 'main');
const ecommerceApp = initializeApp(ecommerceConfig, 'ecommerce');

// Get Firebase services for main app
export const auth = getAuth(mainApp);
export const db = getFirestore(mainApp);
export const storage = getStorage(mainApp);

// Get Firebase services for e-commerce
export const ecommerceAuth = getAuth(ecommerceApp);
export const ecommerceDb = getFirestore(ecommerceApp);
export const ecommerceStorage = getStorage(ecommerceApp);

// Enable offline persistence for main app
try {
    enableIndexedDbPersistence(db, {
        cacheSizeBytes: CACHE_SIZE_UNLIMITED
    }).catch((err) => {
        if (err.code === 'failed-precondition') {
            console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
        } else if (err.code === 'unimplemented') {
            console.warn('The current browser does not support persistence.');
        }
    });
} catch (err) {
    console.error('Error enabling persistence for main app:', err);
}

// Enable offline persistence for e-commerce
try {
    enableIndexedDbPersistence(ecommerceDb, {
        cacheSizeBytes: CACHE_SIZE_UNLIMITED
    }).catch((err) => {
        if (err.code === 'failed-precondition') {
            console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
        } else if (err.code === 'unimplemented') {
            console.warn('The current browser does not support persistence.');
        }
    });
} catch (err) {
    console.error('Error enabling persistence for e-commerce:', err);
}

export const apps = {
    main: mainApp,
    ecommerce: ecommerceApp
};
